export default __webpack_public_path__ + "static/media/facebook.7a0075a8.svg";